import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "space",
  id: "show_section"
};
const _hoisted_2 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item");
  const _component_el_carousel = _resolveComponent("el-carousel");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_carousel, {
    "indicator-position": "none",
    interval: 2000,
    "pause-on-hover": false,
    height: $data.bannerHeight + 'px'
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.imagelist, (item, index) => {
      return _openBlock(), _createBlock(_component_el_carousel_item, {
        key: index
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: item.img,
          alt: "Carousel Image",
          class: "carousel-image"
        }, null, 8, _hoisted_2)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["height"])]);
}